import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-gray-900 border-t border-gray-800 py-4 px-4">
      <div className="max-w-7xl mx-auto flex flex-col sm:flex-row justify-between items-center gap-4">
        <div className="text-gray-500 text-sm">
          © 2026 RydrLink. All rights reserved.
        </div>
        <div className="flex gap-6 text-sm">
          <Link to="/terms" className="text-gray-400 hover:text-purple-400 transition-colors">
            Terms
          </Link>
          <Link to="/privacy" className="text-gray-400 hover:text-purple-400 transition-colors">
            Privacy
          </Link>
          <a href="mailto:info@rydrlinkapp.com" className="text-gray-400 hover:text-purple-400 transition-colors">
            Contact
          </a>
        </div>
      </div>
    </footer>
  );
}
